import { render, staticRenderFns } from "./collapse-all.vue?vue&type=template&id=087eee97&functional=true"
import script from "./collapse-all.vue?vue&type=script&lang=js"
export * from "./collapse-all.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports